import { createAction, props } from '@ngrx/store';
import { Winner } from '@fantaz/shared/data-access/models';

export const load = createAction(
  '[Winner Page] Load',
  props<{
    eventInstanceId: string;
    playInstanceId: string;
    confirmedNow?: boolean | null;
  }>(),
);

export const loadWinnerSuccess = createAction(
  '[Winner/API] Load Winner Success',
  props<{
    winner: Winner;
  }>(),
);

export const loadWinnerFailure = createAction(
  '[Winner/API] Load Winner Failure',
  props<{ error: any }>(),
);

/*
 * Confirm actions
 */

export const confirm = createAction('[Winner Page] Confirm');

export const confirmWinnerSuccess = createAction(
  '[Winner/API] Confirm Winner Success',
);

export const confirmWinnerFailure = createAction(
  '[Winner/API] Confirm Winner Failure',
  props<{ error: any }>(),
);
